import {DI_TOKENS} from '@/di/di.tokens';

import {createInjectionHooks} from 'brandi-react';

const [
  // constants
  useEnvs,
  useConfig,
  useResources,
  useGlobalWindow,
  useClientRoutes,
  // services
  useQueryStringService,
  useLoggerService,
  useLocalStorageService,
  useErrorService,
  useScrollService,
  useNavigationService,
  useTrackingService,
  usePlatformService,
  useProjectUserAuth,
  useTitleAnimation,
  useAssetsLoader,
  useCacheService,
  useDateTimeService,
  useWindowVisibilityService,
  useCookiesService,
  // stores
  useAuthStore,
  useUserStore,
  useUserEnergyStore,
  useModalStore,
  useTimerStore,
  useShareStore,
  useBonusesStore,
  useItemsStore,
  useUserItemsStore,
  useItemModalContentStore,
  useViewportStore,
  useImageLoaderStore,
  useOnboardingStore,
  // useCases
  useOnboardingFinishUseCase,
  useSubscriptionChangeUseCase,
  useShareUseCase,
  useInitializeUseCase,
  useModalControlSharedUseCase,
  useBonusesInfoSharedUseCase,
  useErrorActionHandlerUseCase,
  useItemContentSharedUseCase,
  useOpenItemSharedUseCase,
] = createInjectionHooks(
  // constants
  DI_TOKENS.envs,
  DI_TOKENS.config,
  DI_TOKENS.resources,
  DI_TOKENS.globalWindow,
  DI_TOKENS.clientRoutes,
  // services
  DI_TOKENS.queryStringService,
  DI_TOKENS.loggerService,
  DI_TOKENS.localStorageService,
  DI_TOKENS.errorService,
  DI_TOKENS.scrollService,
  DI_TOKENS.navigationService,
  DI_TOKENS.trackingService,
  DI_TOKENS.platformService,
  DI_TOKENS.projectUserAuth,
  DI_TOKENS.titleAnimation,
  DI_TOKENS.assetsLoader,
  DI_TOKENS.cacheService,
  DI_TOKENS.dateTimeService,
  DI_TOKENS.windowVisibilityService,
  DI_TOKENS.cookiesService,
  // stores
  DI_TOKENS.authStore,
  DI_TOKENS.userStore,
  DI_TOKENS.userEnergyStore,
  DI_TOKENS.modalStore,
  DI_TOKENS.timerStore,
  DI_TOKENS.shareStore,
  DI_TOKENS.bonusesStore,
  DI_TOKENS.itemsStore,
  DI_TOKENS.userItemsStore,
  DI_TOKENS.itemModalContentStore,
  DI_TOKENS.viewportStore,
  DI_TOKENS.imageLoaderStore,
  DI_TOKENS.onboardingStore,
  // useCases
  DI_TOKENS.onboardingFinishUseCase,
  DI_TOKENS.subscriptionChangeUseCase,
  DI_TOKENS.shareUseCase,
  DI_TOKENS.initializeUseCase,
  DI_TOKENS.modalControlSharedUseCase,
  DI_TOKENS.bonusesInfoSharedUseCase,
  DI_TOKENS.errorActionHandlerUseCase,
  DI_TOKENS.itemContentSharedUseCase,
  DI_TOKENS.openItemSharedUseCase,
);

export {
  // constants
  useEnvs,
  useConfig,
  useResources,
  useGlobalWindow,
  useClientRoutes,
  // services
  useQueryStringService,
  useLoggerService,
  useLocalStorageService,
  useErrorService,
  useScrollService,
  useNavigationService,
  useTrackingService,
  usePlatformService,
  useProjectUserAuth,
  useTitleAnimation,
  useAssetsLoader,
  useCacheService,
  useDateTimeService,
  useWindowVisibilityService,
  useCookiesService,
  // stores
  useAuthStore,
  useUserStore,
  useUserEnergyStore,
  useModalStore,
  useTimerStore,
  useShareStore,
  useBonusesStore,
  useItemsStore,
  useUserItemsStore,
  useItemModalContentStore,
  useViewportStore,
  useImageLoaderStore,
  useOnboardingStore,
  // useCases
  useOnboardingFinishUseCase,
  useSubscriptionChangeUseCase,
  useShareUseCase,
  useInitializeUseCase,
  useModalControlSharedUseCase,
  useBonusesInfoSharedUseCase,
  useErrorActionHandlerUseCase,
  useItemContentSharedUseCase,
  useOpenItemSharedUseCase,
};
